import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import './productCEO.scss'

export default function ProductCEO() {
    return (
        <Row className="p-3 px-md-0">
            <Col xs={12} className="p-4 mx-md-0 bg-light  rounded-4 border border-5 border-dark border-opacity-10 border-start-0 border-end-0">
                <Row className="fw-light align-items-center">
                    <Col xs={12} md={3} className="text-center pb-2 pb-md-0">
                        <img src="https://romerpp.pl/zdjecia/wojciechciura.jpg" className="img-fluid boxRem boxRemCeo rounded-circle border border-3 border-dark border-opacity-10" alt="" />
                    </Col>
                    <Col xs={12} md={9}>
                        <em>
                            "Przez 30 lat, w firmie ROMER, z pasją tworzymy kompleksowe systemy do malowania proszkowego, mające ciągły wpływ na rozwój naszej branży. Nasze doświadczenie to nie tylko lata na rynku, ale przede wszystkim zbudowane relacje i zaufanie naszych klientów."
                        </em>
                        <p className="text-end bi bi-feather small pe-4">
                            <em>
                                <strong className="fs-5">CEO ROMER Wojciech Ciura</strong>
                            </em>
                        </p>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}